const cognitoConfig = {
  UserPoolId: "us-east-1_SzVQ9XmI3",
  ClientId: "2svm8ktiv2pst7crrfiofim8ir",
  region: "us-east-1",
};

export default cognitoConfig;
